<template>
  <div class="">
    <el-tabs
      id="tab"
      style=" background: #ffffff;"
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      :stretch="true"
    >
      <el-tab-pane label="我要发单" name="first">
        <div class="text">
          <div class="title">
            <div class="tiao"></div>
            <p>企业信息认证</p>
          </div>
          <div class="renzhen">
            <div
              style=" display: flex;justify-content: flex-end;align-items:center;"
            >
              <span class="title1">企业认证</span>
              <span class="title2">{{ RenZhenZhuangTai }}</span>
            </div>
            <el-divider></el-divider>
            <p class="title3"><i>·</i> 可申请数据采集、数据处理服务</p>
            <!-- <p class="title3"><i>·</i> 可承接数据采集订单</p> -->
          </div>
        </div>
        <div class="table">
          <div class="title">
            <div class="tiao"></div>
            <p>我的发单</p>
          </div>
          <div class="item">
            <div class="clearfix">
              <el-button type="primary" class="chuangjian" @click="elastic()"
                >创建订单</el-button
              >
            </div>

            <el-table
              ref="multipleTable"
              :data="billing"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column
                label="订单名称"
                prop="name"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column prop="id" label="订单编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="type"
                label="订单类型"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                prop="createTime"
                show-overflow-tooltip
              >
                <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
              </el-table-column>
              <el-table-column
                prop="status"
                label="订单状态"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button
                      type="text"
                      icon="el-icon-search"
                      style="color:#505261; margin-right: 10px;"
                      @click="billingcontent(scope.row)"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color:#505261"
                      @click="billingupdate(scope.row)"
                      >删除</el-button
                    >
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>

            <!-- <el-pagination
          layout="prev, pager, next"
          :page-count="total"
          :current-page="reqParams.pageNum"
          @current-change="pager"
        >
        </el-pagination> -->
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我要接单" name="second">
        <div class="text">
          <div class="title">
            <div class="tiao"></div>
            <p>合作伙伴认证</p>
          </div>
          <div class="renzhen_box clearfix renzhen_gundong">
            <div
              class="renzhen"
              style="cursor:pointer;"
              @click="wurenjirenzheng"
            >
              <div
                style=" display: flex;justify-content: flex-end;align-items:center;"
              >
                <span class="title1">无人机合作伙伴</span>
                <span class="title2">{{ CaiJiWuRenJi }}</span>
              </div>
              <el-divider></el-divider>
              <p class="title3"><i>·</i> 可申请本网提供的所有服务</p>
              <p class="title3"><i>·</i> 可承接无人机数据采集订单</p>
            </div>
            <div
              class="renzhen"
              @click="yourenjirenzheng"
              style="margin-left: 40px;cursor:pointer;"
            >
              <div
                style=" display: flex;justify-content: flex-end;align-items:center;"
              >
                <span class="title1">有人机合作伙伴</span>
                <span class="title2">{{ CaiJiYouRenJi }}</span>
              </div>
              <el-divider></el-divider>
              <p class="title3"><i>·</i> 可申请本网提供的所有服务</p>
              <p class="title3"><i>·</i> 可承接有人机数据采集订单</p>
            </div>
            <div
              class="renzhen"
              @click="chulirenzheng"
              style="margin-left: 40px; cursor:pointer;"
            >
              <div
                style=" display: flex;justify-content: flex-end;align-items:center;"
              >
                <span class="title1">数据处理合作伙伴</span>
                <span class="title2">{{ ChuLiZhuangTai }}</span>
              </div>
              <el-divider></el-divider>
              <p class="title3"><i>·</i> 可申请本网提供的所有服务</p>
              <p class="title3"><i>·</i> 可承接数据处理订单</p>
            </div>
          </div>
        </div>
        <div class="table">
          <div class="title">
            <div class="tiao"></div>
            <p>我的接单</p>
          </div>
          <div class="item">
            <el-form
              :inline="true"
              :model="invitationForm"
              size="mini"
              style="float: right;"
              :rules="invitationRules"
              ref="invitationForm"
            >
              <i class="label">邀请码输入：</i>
              <el-form-item prop="invitation">
                <el-input
                  v-model="invitationForm.invitation"
                  placeholder="邀请码输入"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="yaoqinma()"
                ></el-button>
              </el-form-item>
            </el-form>
            <el-table
              ref="multipleTable"
              :data="orders"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column
                label="订单名称"
                prop="name"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column prop="id" label="订单编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="type"
                label="订单类型"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="创建时间"
                prop="createTime"
                show-overflow-tooltip
              >
                <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
              </el-table-column>
              <el-table-column
                prop="dispatchStatus"
                label="订单状态"
                show-overflow-tooltip
                :formatter="onLineStatus"
              >
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button
                      type="text"
                      icon="el-icon-search"
                      style="color:#505261; margin-right: 10px;"
                      @click="orderscontent(scope.row)"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="color:#505261"
                      @click="ordersupdate(scope.row)"
                      >删除</el-button
                    >
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>

            <!-- <el-pagination
          layout="prev, pager, next"
          :page-count="total"
          :current-page="reqParams.pageNum"
          @current-change="pager"
        >
        </el-pagination> -->
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      width="1045px"
      title="请选择您要的服务"
      :visible.sync="DialogFormVisible"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card
            style="height:120px;cursor: pointer;"
            @click.native="qucaiji()"
          >
            <el-col :span="9">
              <img src="../../assets/img/a.png" alt="" />
            </el-col>
            <el-col :span="15">
              <b>数据采集服务</b>
              <p>航空数据采集</p>
            </el-col>
          </el-card>
        </el-col>
        <el-col :span="8"
          ><el-card
            style="height:120px;cursor: pointer;"
            @click.native="quchuli()"
          >
            <el-col :span="9">
              <img src="../../assets/img/b.png" alt="" />
            </el-col>
            <el-col :span="15">
              <b>数据处理服务</b>
              <p>航空数据处理及成果输出</p>
            </el-col>
          </el-card></el-col
        >
        <el-col :span="8"
          ><el-card
            style="height:120px;cursor: pointer;"
            @click.native="caijiandChuLi()"
          >
            <el-col :span="9">
              <img src="../../assets/img/c.png" alt="" />
            </el-col>
            <el-col :span="15">
              <b>一站式服务</b>
              <p>航空数据采集</p>
              <p>航空数据处理及成果输出</p>
            </el-col>
          </el-card></el-col
        >
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :offset="5"
          ><el-card
            style="height:120px;margin-top: 30px;cursor: pointer;"
            @click.native="jieJueFang()"
          >
            <el-col :span="9">
              <img src="../../assets/img/d.png" alt="" />
            </el-col>
            <el-col :span="15">
              <b>解决方案</b>
              <p>全方位数字孪生解决方案</p>
            </el-col>
          </el-card></el-col
        >
        <el-col :span="7"
          ><el-card
            style="height:120px;margin-top: 30px;cursor: pointer;"
            @click.native="qitafuwu()"
          >
            <el-col :span="9">
              <img src="../../assets/img/e.png" alt="" />
            </el-col>
            <el-col :span="15">
              <b>更多服务</b>
            </el-col>
          </el-card></el-col
        >
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      show: true, // 初始启用按钮
      count: "", // 初始化次数

      bianji: true,
      udate: {
        function: "t_user",
        id: "",
        jsonData: { data: {} }
      },
      yaoqinData: {
        //新
        column:
          "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.quote_price price,t_dispatch.data dispatchData",
        // column:
        //   "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.data dispatchData",
        function: "",
        condition: ""
      },
      invitationRules: {
        invitation: [
          { required: true, message: "请输入邀请码", trigger: "blur" },
          { min: 16, max: 16, message: "请输入16位邀请码", trigger: "blur" }
        ]
      },
      invitationForm: {
        invitation: ""
      },
      orders: [],
      billing: [],
      reqParams: {
        function: "t_order,t_user",
        condition: "",
        column:
          "t_order.*,t_user.username,t_user.companyName,t_user.data userData"
      },
      ordersData: {
        function: "t_dispatch,t_order",
        //新
        column:
          "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.quote_price price,t_dispatch.data dispatchData ",
        // column:
        //   "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.data dispatchData",
        condition: ""
      },
      update: {
        function: "t_order",
        ids: ""
      },
      update1: {
        function: "t_dispatch",
        ids: ""
      },
      RenZhen: "",
      RenZhenZhuangTai: "未认证",
      CaiJiYouRenJi: "未认证",
      CaiJiWuRenJi: "未认证",
      ChuLiZhuangTai: "未认证",
      activeName: "first",

      sizeList: ["large", "medium", "small"],
      DialogFormVisible: false,
      details: {},
      userData: {},

      auth1: {},
      qiyezhuangtaizhong: false
    };
  },
  //方法集合
  methods: {
    onLineStatus(row) {
      // console.log(row.dispatchStatus);
      // console.log(row.dispatchEndTime);
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串

      if (userAgent.indexOf("Firefox") > -1) {
        //判断是否Firefox浏览器

        row.dispatchEndTime = row.dispatchEndTime.replace(/-/g, "/"); //运用正则表达式

        if (
          Date.parse(row.dispatchEndTime) < new Date() &&
          row.dispatchStatus == 1
        ) {
          return "已取消";
        }
      }
      if (
        Date.parse(row.dispatchEndTime) < new Date() &&
        row.dispatchStatus == 1
      ) {
        return "已取消";
      }
      if (row.dispatchStatus == 1) {
        return "可接单";
      } else if (row.dispatchStatus == 2) {
        return "已报价";
      } else if (row.dispatchStatus == 3) {
        return "报价失败";
      } else if (row.dispatchStatus == 4) {
        return "已接单";
      } else if (row.dispatchStatus == 5) {
        return "已取消";
      } else if (row.dispatchStatus == 6) {
        return "已报价";
      }
      // if (
      //   Date.parse(row.dispatchEndTime) < new Date() &&
      //   row.dispatchStatus == 1
      // ) {
      //   return "已取消";
      // }
      // if (
      //   Date.parse(row.dispatchEndTime) < new Date() &&
      //   row.hasOwnProperty("dispatchStatus") == false
      // ) {
      //   return "已取消";
      // }
      // if (Date.parse(row.dispatchEndTime) < new Date()) {
      //   return "已取消";
      // }
      // if (row.hasOwnProperty("dispatchStatus") == false) {
      //   return "可接单";
      // }
    },
    //跳转
    chulirenzheng() {
      if (this.qiyezhuangtaizhong) {
        return this.$message({
          message: "请进行完成企业注册激活该功能",
          type: "warning"
        });
      }
      if (this.ChuLiZhuangTai == "认证完成") {
        return this.$message({
          message: "已认证完成",
          type: "success"
        });
      }
      if (this.ChuLiZhuangTai == "认证中") {
        return this.$router.push({
          path: "/certification",
          query: { dataId: "3" }
        });
      }

      this.$router.push("/dataProcessing");
    },
    yourenjirenzheng() {
      if (this.qiyezhuangtaizhong) {
        return this.$message({
          message: "请进行完成企业注册激活该功能",
          type: "warning"
        });
      }
      if (this.CaiJiYouRenJi == "认证完成") {
        return this.$message({
          message: "已认证完成",
          type: "success"
        });
      }
      if (this.CaiJiYouRenJi == "认证中") {
        return this.$router.push({
          path: "/certification",
          query: { dataId: "4" }
        });
      }
      // if (this.userData.type == 7) {
      //   return this.$message({
      //     message: "已认证完成",
      //     type: "success"
      //   });
      // }
      // if (this.userData.type == 9) {
      //   return this.$message({
      //     message: "已认证完成",
      //     type: "success"
      //   });
      // }

      // if (this.userData.auth) {
      //   this.userData.auth.forEach(item => {
      //     if (item.type == 4) {
      //       this.auth1 = item;
      //     }
      //   });

      //   if (
      //     this.auth1.status == 1 &&
      //     this.userData.data.hasOwnProperty("yourenji")
      //   ) {
      //     return this.$router.push({
      //       path: "/certification",
      //       query: { dataId: "4" }
      //     });
      //   }
      // }
      // this.$router.push("/dataAcquisition");
      this.$router.push("/dataAcquisitionSecond");
    },
    wurenjirenzheng() {
      if (this.qiyezhuangtaizhong) {
        return this.$message({
          message: "请进行完成企业注册激活该功能",
          type: "warning"
        });
      }

      if (this.CaiJiWuRenJi == "认证完成") {
        return this.$message({
          message: "已认证完成",
          type: "success"
        });
      }
      if (this.CaiJiWuRenJi == "认证中") {
        return this.$router.push({
          path: "/certification",
          query: { dataId: "2" }
        });
      }
      // if (this.userData.type == 5) {
      //   return this.$message({
      //     message: "已认证完成",
      //     type: "success"
      //   });
      // }
      // if (this.userData.type == 9) {
      //   return this.$message({
      //     message: "已认证完成",
      //     type: "success"
      //   });
      // }

      // if (this.userData.auth) {
      //   this.userData.auth.forEach(item => {
      //     if (item.type == 2) {
      //       this.auth1 = item;
      //     }
      //   });

      //   if (
      //     this.auth1.status == 1 &&
      //     this.userData.data.hasOwnProperty("wurenji")
      //   ) {
      //     // console.log("认证中");
      //     return this.$router.push({
      //       path: "/certification",
      //       query: { dataId: "2" }
      //     });
      //   }
      // }

      this.$router.push("/dataAcquisition");
    },

    //详情跳转
    orderscontent(row) {
      // console.log(row)
      this.$router.push({
        name: `AcceptDetails`,
        params: {
          data: row
        }
      });
      // this.$router.push("/orderContent");
    },
    billingcontent(row) {
      // console.log(row)
      this.$router.push({
        name: `orderContent`,
        params: {
          data: row
        }
      });
      // this.$router.push("/orderContent");
    },
    //接单删除
    ordersupdate(row) {
      // console.log(row);
      if (row.dispatchStatus == "可接单") {
        return this.$message.error(
          "订单当前状态不可删除如有问题联系13811918203"
        );
      }
      if (row.dispatchStatus == "已报价") {
        return this.$message.error(
          "订单当前状态不可删除如有问题联系13811918203"
        );
      }
      if (row.dispatchStatus == "已接单") {
        return this.$message.error(
          "订单当前状态不可删除如有问题联系13811918203"
        );
      }
      this.$confirm("确认要删除订单吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          console.log(row.dispatchId);
          this.update1.ids = row.dispatchId;
          const { data: dt } = await this.$http.post(
            "general/delete",
            this.update1
          );
          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          this.ordersonLoad();
        })
        .catch(() => {});
    },
    //发单删除
    billingupdate(row) {
      // console.log(row.status);
      if (row.status == "审核中") {
        return this.$message.error(
          "订单正在审核中如果想删除订单请联系13811918203"
        );
      }
      if (row.status == "已接单") {
        return this.$message.error(
          "订单当前状态不可删除如有问题联系13811918203"
        );
      }

      this.$confirm("确认要删除订单吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.update.ids = row.id;
          const { data: dt } = await this.$http.post(
            "general/delete",
            this.update
          );
          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          this.billingonLoad();
        })
        .catch(() => {});
    },
    //页面跳转订单
    qitafuwu() {
      this.$router.push("/otherServices");
    },
    jieJueFang() {
      this.$router.push("/solution");
    },
    caijiandChuLi() {
      this.$router.push("/acquisitionProcessing");
    },
    quchuli() {
      this.$router.push("/dataProcessingOrder");
    },
    qucaiji() {
      this.$router.push("/dataCollection");
    },
    elastic() {
      this.DialogFormVisible = true;
    },
    //邀请码输入
    yaoqinma() {
      this.$refs.invitationForm.validate(async valid => {
        if (valid) {
          this.yaoqinData.function = `t_order left join t_dispatch on t_dispatch.orderId = t_order.id and t_dispatch.userId=${window.sessionStorage.getItem(
            "userId"
          )}`;
          this.yaoqinData.condition = `t_order.id=${
            this.invitationForm.invitation
          } and t_order.userId!=${window.sessionStorage.getItem("userId")}`;
          const { data: dt } = await this.$http.post(
            "general/query",
            this.yaoqinData
          );

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          this.orders = dt.data;

          // 修改data中的表格数据  驱动视图改变
          // this.tableData = dt.data.data.length;

          this.orders.forEach(e => {
            if (Date.parse(e.dispatchEndTime) < new Date()) {
              this.danqishijian = true;
            }
            if (e.type == 1) {
              e.type = "数据采集服务";
            } else if (e.type == 2) {
              e.type = "数据处理服务";
            } else if (e.type == 3) {
              e.type = "一站式";
            }
            // if (e.dispatchStatus == 1) {
            //   e.dispatchStatus = "可接单";
            // } else if (e.dispatchStatus == 2) {
            //   e.dispatchStatus = "已报价";
            // } else if (e.dispatchStatus == 3) {
            //   e.dispatchStatus = "报价失败";
            // } else if (e.dispatchStatus == 4) {
            //   e.dispatchStatus = "已接单";
            // } else if (e.dispatchStatus == 5) {
            //   e.dispatchStatus = "已取消";
            // }
          });
        }
      });
    },
    //接单列表
    async ordersonLoad() {
      this.ordersData.condition = `t_dispatch.orderId=t_order.id and t_dispatch.userId=${window.sessionStorage.getItem(
        "userId"
      )} order by createTime desc`;
      const { data: dt } = await this.$http.post(
        "general/query",
        this.ordersData
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      // this.total = Math.ceil(dt.data.total / this.reqParams.pageSize);

      this.orders = dt.data;

      // 修改data中的表格数据  驱动视图改变

      // console.log(this.tableData);

      this.orders.forEach(e => {
        if (Date.parse(e.dispatchEndTime) < new Date()) {
          this.danqishijian = true;
        }
        if (e.type == 1) {
          e.type = "数据采集服务";
        } else if (e.type == 2) {
          e.type = "数据处理服务";
        } else if (e.type == 3) {
          e.type = "一站式";
        }

        // if (
        //   Date.parse(e.dispatchEndTime) > new Date() &&
        //   e.dispatchStatus == 1
        // ) {
        //   e.dispatchStatus = "可接单";
        // } else if (e.dispatchStatus == 2) {
        //   e.dispatchStatus = "已报价";
        // } else if (e.dispatchStatus == 3) {
        //   e.dispatchStatus = "报价失败";
        // } else if (e.dispatchStatus == 4) {
        //   e.dispatchStatus = "已接单";
        // } else if (e.dispatchStatus == 5) {
        //   e.dispatchStatus = "已取消";
        // } else if (
        //   Date.parse(e.dispatchEndTime) < new Date() &&
        //   e.dispatchStatus == 1
        // ) {
        //   e.dispatchStatus = "已取消";
        // }

        // if (e.status == 9) {
        //   this.tableData.splice(a, 1, this.tableData.pop());

        // }
        e.createTime = e.createTime.substring(0, 10);
      });
    },
    //发单列表
    async billingonLoad() {
      this.reqParams.condition = `t_order.userId=t_user.id and (t_order.type=1 or t_order.type=2 or t_order. type=3) and t_user.id=${window.sessionStorage.getItem(
        "userId"
      )} order by createTime desc`;
      const { data: dt } = await this.$http.post(
        "general/query",
        this.reqParams
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      // this.total = Math.ceil(dt.data.total / this.reqParams.pageSize);

      this.billing = dt.data;

      // 修改data中的表格数据  驱动视图改变

      // console.log(this.tableData);
      this.billing.forEach(e => {
        if (e.type == 1) {
          e.type = "数据采集服务";
        } else if (e.type == 2) {
          e.type = "数据处理服务";
        } else if (e.type == 3) {
          e.type = "一站式";
        }
        if (e.status == 1) {
          e.status = "审核中";
        } else if (e.status == 2) {
          e.status = "未通过";
        } else if (e.status == 3) {
          e.status = "审核中";
        } else if (e.status == 4) {
          e.status = "审核中";
        } else if (e.status == 5) {
          e.status = "已接单";
        }
        // if (e.status == 9) {
        //   this.tableData.splice(a, 1, this.tableData.pop());
        //   console.log(this.tableData);
        // }
        e.createTime = e.createTime.substring(0, 10);
      });
    },
    //个人信息
    async content() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      this.userData = dt.data;
      this.udate.id = this.userData.id;
      //   this.companyName.companyName = this.userData.companyName;
      //   this.username.username = this.userData.username;
      this.details = JSON.parse(this.userData.data);
      // console.log(this.userData.type);
      if (this.userData.type == 0) {
        this.qiyezhuangtaizhong = true;
      }
      this.userData.auth.forEach(e => {
        if (e.type == 1) {
          if (e.status == 1) {
            this.qiyezhuangtaizhong = true;
            this.RenZhenZhuangTai = "认证中";
          }
          if (e.status == 2) {
            this.qiyezhuangtaizhong = true;
            this.RenZhenZhuangTai = "认证驳回";
          }
          if (e.status == 3) {
            this.RenZhenZhuangTai = "认证完成";
          }
        }
        if (e.type == 2) {
          if (e.status == 1) {
            this.CaiJiWuRenJi = "认证中";
          }
          if (e.status == 2) {
            this.CaiJiWuRenJi = "认证驳回";
          }
          if (e.status == 3) {
            this.CaiJiWuRenJi = "认证完成";
          }
        }
        if (e.type == 4) {
          if (e.status == 1) {
            this.CaiJiYouRenJi = "认证中";
          }
          if (e.status == 2) {
            this.CaiJiYouRenJi = "认证驳回";
          }
          if (e.status == 3) {
            this.CaiJiYouRenJi = "认证完成";
          }
        }

        if (e.type == 3) {
          if (e.status == 1) {
            this.ChuLiZhuangTai = "认证中";
          }
          if (e.status == 2) {
            this.ChuLiZhuangTai = "认证驳回";
          }
          if (e.status == 3) {
            this.ChuLiZhuangTai = "认证完成";
          }
        }
      });
      if (this.userData.type == 6) {
        this.CaiJiWuRenJi = "认证完成";
        this.CaiJiYouRenJi = "认证完成";
      }
      if (this.userData.type == 5) {
        this.CaiJiWuRenJi = "认证完成";

        this.ChuLiZhuangTai = "认证完成";
      }
      if (this.userData.type == 7) {
        this.CaiJiYouRenJi = "认证完成";
        this.ChuLiZhuangTai = "认证完成";
      }
      if (this.userData.type == 9) {
        this.CaiJiWuRenJi = "认证完成";
        this.CaiJiYouRenJi = "认证完成";
        this.ChuLiZhuangTai = "认证完成";
      }
    },
    handleClick(tab) {
      if (tab.label == "我要发单") {
        this.billingonLoad();
      }
      if (tab.label == "我要接单") {
        this.ordersonLoad();
      }
    }
  },
  created() {
    this.content();
    this.billingonLoad();
    // this.ordersonLoad();
    sessionStorage.removeItem("orderData");
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
#tab/deep/ .is-active {
  background-color: #0087ff !important;
  color: #fff;
}
#tab/deep/.el-tabs__nav {
  border: 0;
}
#tab/deep/ .el-tabs__header {
  margin: 0;
}
.el-tab-pane {
  background: #f7f4f8;
}
.text {
  background: #ffffff;
  // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  padding: 40px;
  padding-top: 20px;
  border: 1px solid #e5e5e5;
  border-top: 0;
  opacity: 1;
}
.title {
  margin-bottom: 30px;
  //   padding: 20px;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  .tiao {
    margin-right: 10px;
    width: 4px;
    height: 16px;
    background: #0086fd;
  }
}
.renzhen {
  box-sizing: border-box;
  //   margin-left: 20px;
  width: 360px;
  background: url("../../assets/img/1.0renzheng.png") no-repeat center;
  padding: 30px;
  background-size: 100% 100%;
  .title1 {
    color: #ffffff;
    font-weight: 600;
    font-size: 20px;
    margin-right: auto;
  }
  .title2 {
    color: #ffffff;
    font-size: 14px;
  }
  .title3 {
    margin: 0;
    padding-top: 20px;
    color: #ffffff;
    font-size: 14px;
    i {
      font-size: 14px;
    }
  }
  .el-divider {
    margin: 0;
    margin-top: 20px;
  }
}
.table {
  margin-top: 30px;
  background: #ffffff;
  padding: 40px;
  border: 1px solid #e5e5e5;
}
.renzhen_box {
  display: -webkit-box;
  white-space: nowrap;
  overflow: hidden;
  backface-visibility: hidden;
  perspective: 1000;
  -webkit-overflow-scrolling: touch;
  text-align: justify;
  overflow-x: initial;
}
i {
  font-style: normal;
}
.chuangjian {
  float: right;
}
// .renzhen_gundong::-webkit-scrollbar {
//   height: 10px; /*对水平流动条有效*/
// }
// /*定义两端按钮的样式*/
// .renzhen_gundong::-webkit-scrollbar-button {
//   background-color: cyan;
// }
// /*定义滚动条的轨道颜色、内阴影及圆角*/
// .renzhen_gundong::-webkit-scrollbar-track {
//   box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//   background-color: rosybrown;
//   border-radius: 3px;
// }
// /*定义滑块颜色、内阴影及圆角*/
// .renzhen_gundong::-webkit-scrollbar-thumb {
//   border-radius: 7px;
//   box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//   background-color: #e8e8e8;
// }
// /*定义右下角汇合处的样式*/
// .renzhen_gundong::-webkit-scrollbar-corner {
//   background: khaki;
// }
</style>
